import {Component, OnInit, ViewChild} from '@angular/core';
import {Drawer} from 'primeng/drawer';
import {CurrentUser, CurrentUserService} from '../services/current-user.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css',
    standalone: false
})
export class LayoutComponent implements OnInit {

  currentUser: CurrentUser | null = null;

  @ViewChild('drawerRef') drawerRef!: Drawer;
  visible: boolean = false;

  constructor(private currentUserService: CurrentUserService) {}

  ngOnInit(): void {
    this.currentUserService.getCurrentUser().subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  get initials(): string {
    if (!this.currentUser) return '?';
    const first = this.currentUser.firstName?.[0] ?? '';
    const last = this.currentUser.lastName?.[0] ?? '';
    return (first + last).toUpperCase() || this.currentUser.userName?.[0]?.toUpperCase() || '?';
  }

  closeCallback(e: Event): void {
    this.drawerRef.close(e);
  }
}
